import image from "./../../images/nkipr-text.png";

const Content = () => {
  return (
    <section className="relative py-10" dir="rtl">
      <div className="container mx-auto px-10 text-right">
        <img
          className="float-right mb-5 ml-10 w-1/2"
          src={image}
          alt="Portugal img"
        />

        <h1 className="pb-10 text-2xl font-bold">
          סקירת מצבו השוטף של שוק הנדל"ן בצפון קפריסין
        </h1>
        <p>
          השנה האחרונה היוותה שלב התפתחות חדש עבור שוק הדיור בצפון קפריסין. לצד
          הקמה ופיתוח תשתיות והגדלת היקפי הבניה גדלים גם מחירי הנדל"ן.
          <br />
          <br /> הקונים שרכשו אך לפני 6-7 שנים נכסים קטנים ביעדים הפופולריים שלא
          זכו להערכה ראויה בזמנו, הרוויחו כ200–250 אחוז מעלות הנכסים כבר היום,
          זאת בשל העלייה בעלות מ"ר דיור. הנתונים האלה לצד המשך צמיחת המחירים
          מושכים אל האזור משקיעים נוספים, הרואים את הנולד.
          <br />
          <br /> סיבות נוספות לעלייה חדה בכמות הרוכשים הזרים: מדיניות ידידותית
          כלפי משקיעים, רמת סיכון נמוכה בהשקעות בנדל"ן צפון קפריסין, בטחון אישי
          ומחירים סבירים לדיור עממי ומגורי יוקרה.
          <br />
          <br /> כתגובה לעניין המשקיעים התרחבה תעשיית הבניה. היזמים בשאיפתם לספק
          באופן מיטבי את צרכי המשקיעים הזרים החלו להשקיע תשומת לב מרבית באיכות
          מתחמי המגורים, עיצוב ותכנון הדירות כשהם מכינים את הנכסים לקראת אכלוס.
          רמת העניין נשמרת גם בשל כך שכמות חלקות הקרקע באי מוגבלת. כבר היום קיים
          חוסר בשטחי בניה יוקרתיים.
          <br />
          <br /> באשר לעלויות הבניה, המחירים בשוק השניוני גבוהים ממחירי הנדל"ן
          החדש.
          <br />
          <br /> כיום ניתן לרכוש דירה בשטח 50-70 מ"ר במתחם מגורים בשלבי בניה
          בעירים פמגוסטה, קירניה או אסנטפה תמורת סך ממוצע של 80000-140000 יורו.
          מחיר הווילות בשלבי בניה נע בין 200000 ל400000 יורו. יש לקחת בחשבון גם
          את התנאים שמציעות חברות הבניה בתקופת ההקמה.
          <br />
          <br /> עלות דירות מוכנות מרווחות בשטח 80-100 מ"ר באזור מכובד הנה בסדר
          גודל של 150000-180000 יורו. נדל"ן בקרבת החוף הנו יקר יותר כצפוי, היות
          והוא מבטיח לבעליו החזר השקעה גבוה בטווח הארוך והבינוני. <br />
          <br />
          בהתחשב בתנאי מכירה נוחים, נצפית היום תחרות בין המשקיעים. כך מי שמקבל
          לבעלותו את הנכס המבוקש ביותר הוא מי שהיה הראשון להעביר את הכספים
          לחשבון היזם או הבעלים.
        </p>
        <h1 className="py-10 text-2xl font-bold">
          השקעה בנדל"ן בצפון קפריסין – היתרונות
        </h1>
        <p>
          הנדל"ן בצפון קפריסין מעורר עניין הולך וגובר אצל המשקיעים הזרים. אזור
          הים התיכון מעניק לבעלי הנדל"ן מספר יתרונות, ביניהם:
        </p>

        <ul className="list-disc space-y-2 pt-5 pr-5" dir="rtl">
          <li>300 ימי שמש בשנה.</li>
          <li>חופי חול ציוריים והתכלת הטהורה של הים התיכון.</li>
          <li>סביבה אקולוגית מעולה.</li>
          <li>שיעורי פשיעה נמוכים.</li>
          <li>מחירי דיור סבירים.</li>
          <li>מוצרי מזון איכותיים.</li>
          <li> אורח חיים ים תיכוני.</li>
          <li> שיעורי מס נמוכים.</li>
          <li> יחס ידידותי של השלטון כלפי מקור הכנסת התושבים הזרים</li>
        </ul>
        <p className="py-10">
          אלו רק חלק מהיתרונות שמבטיחה רכישת הנדל"ן בצפון קפריסין.
        </p>
        <p>נתייחס בפירוט ל10 היתרונות החשובים ביותר:</p>
        <ul className="list-decimal space-y-5 pt-5 pr-5" dir="rtl">
          <li>
            שערי חליפין כדאיים.
            <br />
            <br /> ניתן לרכוש דירה או וילה בצפון קפריסין עבור כל מטבע. כך תשלום
            בלירה שטרלינג הבריטית מבטיח לקונים חסכון משמעותי ומעניק הזדמנות
            לרכוש דיור איכותי ומרווח יותר במחיר נמוך יותר, הודות לשער חליפין
            הכדאי.
          </li>
          <li>
            המורשת הקולוניאלית של בריטניה
            <br />
            <br /> תושבי אירופה השקיעו בבינוי קפריסין הצפונית במשך מספר עשורים.
            גם כיום באי שהיה בעבר מושבה בריטית נשמרת במידת מה אווירת האימפריה
            לשעבר: אנגלית כשפה רשמית, תנועה בצד שמאל, שמות ושלטים בשפות אנגלית
            והתורכית, הכנסייה האנגליקנית, מבנים מרהיבים מהתקופה החולפת. לירה
            שטרלינג האנגלית אינה המטבע הרשמי, אך הנפוץ ביותר.
          </li>
          <li>
            הזדמנויות השקעה אטרקטיביות
            <br />
            <br /> רכישת נכס מבוקש באזורי הנופש במחיר נח מבטיחה תשואה גבוהה
            משכירות. מה שחשוב הוא שאלה הם מאפיינים של כל כמעט אזור נופש בצפון
            קפריסין. חברות בניה רבות מציעות לרכוש דיור במתחמים שלהן בתנאי שכירות
            מובטחת. הרווחיות מהשכרה הנה 6-12 אחוזים בשנה, נתון גבוה משמעותית
            מהמדדים הממוצעים במדידות אירופה.
          </li>
          <li>
            אווירה נעימה
            <br />
            <br /> היופי הטבעי ומורשת היסטורית מרתקת, מסורת הכנסת האורחים של
            התושבים המקומיים והאווירה השלווה מושכים לקפריסין יותר ויותר תושבים
            זרים.
          </li>
          <li>
            ביטחון
            <br />
            <br /> על פי הסטטיסטיקה, צפון קפריסין נמצאת בראשית רשימת המדינות
            הבטוחות ביותר שאוכלוסייתן מונה פחות מ5 מיליון תושבים. קטגוריית
            מדינות זו כוללת גם את איסלנד, לוקסמבורג, מלטה, סלובניה ועוד.
          </li>
          <li>
            מחירי דיור נוחים
            <br />
            <br /> גם אם בידי משקיע זר סכום קטן יחסית, ביכולתו עדיין לרכוש דירה
            איכותית לצורך נופש או מגורים באי. מובן שקיימות גם הצעות יוקרתיות
            עבור משקיעים בעלי אמצעים, אך דווקא הדיור הנגיש הוא הגורם העיקרי
            לצמיחה כלכלית של הרפובליקה.
          </li>
          <li>
            רווחי המכירה
            <br />
            <br /> במקרה של בחירת נכס מושכלת והשקעה בשלב ה pre-launch ו
            off-planהרווח יכול להגיע ל 50%
          </li>
        </ul>
        <h1 className="py-10 text-2xl font-bold">תהליך ההשקעה</h1>
        <p>
          נושא חשוב, שעל המשקיעים להקדיש לו את מלוא תשומת הלב בשלב איתור הנכס –
          בחירת האזור. בצפון קפריסין 5 מחוזות מבוקשים, לכל אחד יתרונות ומאפיינים
          ייחודיים: קירניה, פמגוסטה, לפקושה, גוזליורט, איסקלה. בחירת היישוב
          תלויה לחלוטין במטרות הרכישה. לאחר בחירת המיקום ניתן לגשת לעסקה עצמה.
          <br />
          <br />
          תהליך ההשקעה די קבוע ומתחלק למספר שלבים עוקבים:
          <br />
          <br /> מקצוענים מוסמכים מטעמינו מסייעים בסגירת עסקאות רכישה, מכירה
          והשכרת הדיור בשטח צפון קפריסין. אנו מאתרים את הנכס, מכינים את ההסכם
          ומלווים את העסקה מבחינה משפטית. בנוסף אנו מציעים שרות שלאחר המכירה
          וניהול הנכסים שנרכשו.
        </p>
        <ul className="list-decimal space-y-2 pt-5 pr-5" dir="rtl">
          <li>
            איתור הנכס. המומחים שלנו יבחרו את הנכס המתאים ביותר לדרישותיו
            האישיות של המשקיע.
          </li>
          <li>
            נסיעת היכרות. סוכנות הנדל"ן מארגנת ביקור בן 3-5 ימים ללא תשלום,
            במהלכו תוכלו לראות את כל הנכסים המועדפים ולהגיע להחלטה הסופית.
          </li>
          <li>
            בדיקת חוקיות המסמכים המשפטיים ותיאום תנאי המכירה. המומחים שלנו
            לוקחים על עצמם את כל ההתחייבויות לבדיקת מסמכי הבעלות עבור מושא
            המכירה ויסייעו לכם להגיע לתנאי קניה הסבירים ביותר.
          </li>
          <li>
            העברת הפקדון וחתימה על ההסכם. לאחר תיאום המחיר הקונה מעביר למוכר
            פיקדון/מקדמה ומאשר בכך את רצינות כוונותיו. בשלב זה נחתם הסכם המכירה
            ונקבעים תנאי התשלום.
          </li>
          <li>
            רישום הנדל"ן. לאחר העברת מלוא התשלום עבור הנכס או מתן מקדמה, בהתאם
            לתנאי היזם, ההסכם נרשם בלשכת רשם המקרקעים וזכויות הבעלות נרשמות על
            שמו של בעליו החדשים של הנכס.
          </li>
        </ul>
        <p className="py-10">
          כל השלבי ההשקעה בנדל"ן בצפון קפריסין ניתנים לביצוע מרחוק, ז"א אונליין.
        </p>
        <p className="font-bold">
          נציגינו בצפון קפריסין יסייעו לרוכשים להתמודד עם מאפיינים ייחודיים ודקויות תהליך רכישת הדיור. מרגע הנחיתה בנמל התעופה ועד לעזיבתכם, יתלוו אליכם בעלי מקצוע מוסמכים מטעמינו בפורטוגל. עם ליווי מקצועי, תמיכה והדרכה מושכלת תימנעו מגורמי סיכון וטעויות בבחירת הנכס וסגירת העסקה, שעלולות לגרום לבעיות משפטיות ופיננסיות בהמשך. 
        </p>
      </div>
    </section>
  );
};

export default Content;
